module.exports = __webpack_public_path__ + "static/media/Urgheim_Universitet.f4b60a45.md";